var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-black"},[_c('div',{staticClass:"container py-3"},[_c('div',{staticClass:"row pt-1 align-items-center"},[_c('div',{staticClass:"col-xl-6 col-bg-6 col-md-6 col-sm-12 pbelow",staticStyle:{"color":"white"}},[_c('span',[_vm._v("© 2023 Amalina Ahmad")])])])])])
}]

export { render, staticRenderFns }